module.exports = "<div class=\"kl-crumb-item f-cb {class}\">\n    {#if this != this.$outer.data.crumbArr[0]}\n    <span class=\"kl-crumb-item__separator\">{#inc this.$outer.data.separator}</span>\n    {/if}\n\n    <div class=\"kl-crumb-item__cnt\">\n        {#if href}\n            <a class=\"kl-crumb-item__link\" href=\"{href}\">{#inc content || this.$body}</a>\n        {#else}\n            {#inc content || this.$body}\n        {/if}\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ../src/js/components/navigation/KLCrumb/KLCrumbItem/index.html
// module id = 515
// module chunks = 0